import { Injectable } from "@angular/core";
import { Subscription } from "@app-cmc/models";
import { BehaviorSubject, Observable } from "rxjs";
import { DataService } from "../core/services/data.service";
import { NotificationModel } from "../models/notification";
import { LocationService } from "./location.service";

@Injectable({
  providedIn: "root"
})
// todo: divide service into API and data services
export class CompanyDataService {
  private serviceUrl = "company";
  private $subscriptionSbj$: BehaviorSubject<Subscription | null> = new BehaviorSubject<Subscription | null>(null);
  private notifications: Array<NotificationModel> = [];
  private notificationsSbj$: BehaviorSubject<Array<NotificationModel>> = new BehaviorSubject<Array<NotificationModel>>(this.notifications);

  readonly notificationsChanged$: Observable<Array<NotificationModel>> = this.notificationsSbj$.asObservable();
  readonly subscriptionChanged$: Observable<Subscription | null> = this.$subscriptionSbj$.asObservable();

  constructor(private http: DataService, private locationSvc: LocationService) {}

  private getNotifications(locationId: number): Observable<Array<NotificationModel>> {
    return this.http.get(`${this.serviceUrl}/notifications/${locationId}`, {});
  }

  private getSubscription(): Observable<Subscription> {
    return this.http.get(`${this.serviceUrl}/subscription`, {});
  }

  // todo: refactor, remove subscriptions from service:
  retrieveData(onlySubscription: boolean = false) {
    if (!onlySubscription) {
      this.getNotifications(this.locationSvc.getSelectedLocationId()).subscribe((x) => {
        this.notifications = x;
        this.notificationsSbj$.next(this.notifications);
      });
    }

    this.getSubscription().subscribe((subscription) => {
      this.$subscriptionSbj$.next(subscription);
    });
  }
}
